import {useState, useEffect, useRef, useCallback} from "react";
import {inject, observer} from "mobx-react";
import RoutesSchedulesGrid from "./RoutesSchedulesGrid";
import {db} from "../../../../firebase/Firebase";
import Alerts from "../../../../palette/Alerts";
import {LayoutChild} from "../../../../palette/Palette";
import RoutesSchedulesForm from "./RoutesSchedulesForm";
import {Animated} from "react-animated-css";
import RoutesSchedulesFormEdit from "./RoutesSchedulesFormEdit";

const useMountedState = () => {
    const mountedRef = useRef(false)
    const isMounted = useCallback(() => mountedRef.current, [])

    useEffect(() => {
        mountedRef.current = true

        return () => {
            mountedRef.current = false
        }
    }, [])

    return isMounted
}

function CreateRoutesSchedules(props) {

    const {DataStore, ControlStore} = props
    const {companyName, idCompany,} = DataStore
    const {typesVehiclesFinished} = ControlStore

    const [load, setLoad] = useState(false)
    const [dataSource, setDataSource] = useState([])
    const [visibleGrid, setVisibleGrid] = useState(true)
    const [visibleForm, setVisibleForm] = useState(false)
    const [edit, setEdit] = useState(false)
    const [trigger, setTrigger] = useState(false)
    const [dataEdit, setDataEdit] = useState({})

    const isMounted = useMountedState()

    useEffect(() => {
        const GetRoutes = async () => {

            await db.collection(companyName).doc(idCompany).collection('Routes')
                .onSnapshot(function (querySnapshot) {
                    const data = []
                    let ID = 0
                    querySnapshot.forEach(function (doc) {
                        ID = ID + 1
                        const obj = {...doc.data(), id: doc.id, ID: ID};
                        data.push(obj);
                    });
                    setLoad(true)
                    data.length > 0 && ControlStore.getRoutesSchedulesControl(true)
                    console.log(data)
                    setDataSource([...data]);
                })
        }
        if (isMounted()) {
            GetRoutes().catch(() => setTrigger(!trigger))
        }
    }, [ControlStore, companyName, idCompany, isMounted, trigger])

    return (
        <>
            {!typesVehiclesFinished &&
            <LayoutChild percent={95} margin='auto' top={25}>
                <Alerts severity={'warning'} body={'¡No se han gestionado los tipos de vehículos!'}/>
            </LayoutChild>}

            {(typesVehiclesFinished && visibleGrid) &&
            <Animated animationIn="fadeIn" animationOut="slideOutUp" isVisible={visibleGrid}>
                <RoutesSchedulesGrid load={load} dataSource={dataSource} setEdit={setEdit}
                                     setVisibleForm={setVisibleForm} setVisibleGrid={setVisibleGrid}
                                     setDataEdit={setDataEdit} DataStore={DataStore} setTrigger={setTrigger}
                                     trigger={trigger}/>
            </Animated>}


            {visibleForm &&
            <Animated animationIn="fadeIn" animationOut="slideOutUp" isVisible={visibleForm}>
                <RoutesSchedulesForm setVisibleForm={setVisibleForm} setTrigger={setTrigger} trigger={trigger}
                                     DataStore={DataStore} setVisibleGrid={setVisibleGrid} dataSource={dataSource}/>
            </Animated>}

            {edit &&
            <Animated animationIn="fadeIn" animationOut="slideOutUp" isVisible={edit}>
                <RoutesSchedulesFormEdit DataStore={DataStore} setVisibleGrid={setVisibleGrid} setEdit={setEdit}
                                         dataEdit={dataEdit} dataSource={dataSource} setTrigger={setTrigger}
                                         trigger={trigger}/>
            </Animated>
            }
        </>
    )
}


export default inject('DataStore', 'ControlStore')(observer(CreateRoutesSchedules));
